import styled from "styled-components";
import wavyOctagon from "../../../assets/images/general/wavy-octagon.png";
import { fonts } from "../../../styles/variables";
import breakpoints from "../../../styles/breakpoints";
import { safeAreaTopPaddingPlus } from "../../../styles/safeArea";
import Button from "../../atoms/Button";
import cog from "../../../assets/images/icons/cog.svg";

export const OuterContainer = styled.div<{
  isBadgeRelatedWinesShown?: boolean;
}>`
  width: 100%;
  padding: ${(props) => (props.isBadgeRelatedWinesShown ? "20px 20px 40px" : "20px 20px 60px")};
  ${breakpoints.smUp} {
    padding: ${(props) => (props.isBadgeRelatedWinesShown ? "20px 20px 40px" : "20px 20px 80px")};
    margin-bottom: ${(props) => (props.isBadgeRelatedWinesShown ? "0" : "20px")};
  }
`;

export const Header = styled.div`
  ${safeAreaTopPaddingPlus(20)}
  padding-right: 30px;
  padding-bottom: 20px;
  padding-left: 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const Cross = styled.img`
  height: 15px;
  width: 15px;
  position: absolute;
  left: 0;
  cursor: pointer;
  margin: 0 15px;
  z-index: 1;
`;

export const OptionsButton = styled.div`
  display: flex;
  flex-flow: row;
  cursor: pointer;
  height: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const OptionsButtonText = styled.div`
  font-weight: 900;
  font-family: ${fonts.fontInterstateUltraBlack};
  letter-spacing: 1.1px;
  font-size: 13px;
  text-transform: uppercase;
`;

export const Cog = styled.img.attrs(() => ({
  src: cog,
}))`
  height: 23px;
  width: 23px;
  cursor: pointer;
  margin: 0 10px;
`;

export const ChallengeBadgeImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ChallengeBadgeImageBackground = styled.div<{ isEarned: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 200px;
  ${breakpoints.xsDown} {
    height: 132px;
    width: 132px;
  }
  background: url("${wavyOctagon}") no-repeat 100% 100% / cover;
  filter: ${({ isEarned }) => (isEarned ? "grayscale(0)" : "grayscale(100%)")};
`;

export const ChallengeBadgeImage = styled.img<{ isEarned: boolean }>`
  height: 140px;
  width: 140px;
  ${breakpoints.xsDown} {
    height: 95px;
    width: 95px;
  }
  filter: ${({ isEarned }) => (isEarned ? "grayscale(0)" : "grayscale(100%)")};
`;

export const StatusClaimedImage = styled.img`
  height: 12px;
  width: 14px;
  margin-top: 15px;
`;

export const StatusTag = styled.span`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  background-color: ${(props) => props.color};
  padding: 4px 10px;
  border-radius: 1rem;
  font-size: 10px;
  font-family: ${fonts.fontBauMedium};
  margin-top: 15px;
`;

export const ChildBadgeContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  margin: 30px 0;
`;

export const ChildBadgeWrapper = styled.div`
  width: 33.333%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const PointsText = styled.h3`
  font-size: 35px;
  line-height: 30px;
  ${breakpoints.xsDown} {
    font-size: 25px;
  }
  font-family: ${fonts.fontInterstateBlackCompressed};
  text-align: center;
  margin-bottom: 30px;
`;

export const StartButton = styled(Button).attrs(() => ({
  full: true,
  lg: true,
}))`
  margin-bottom: 32px;
`;

export const ClaimButton = styled(Button).attrs(() => ({
  full: true,
  lg: true,
  warning: true,
}))`
  margin-bottom: 32px;
`;

export const ChallengeDescription = styled.p`
  font-size: 18px;
  line-height: 24px;
  ${breakpoints.xsDown} {
    font-size: 14px;
    line-height: 20px;
  }
  font-family: ${fonts.fontBauRegular};
  text-align: center;
  margin-bottom: 32px;
`;

export const AlertTitle = styled.h4`
  display: inline-block;
  font-size: 11px;
  line-height: 10px;
  font-family: ${fonts.fontInterstateUltraBlack};
  font-weight: 900;
  text-transform: uppercase;
`;
